import { InputConfig } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationJobPositionStatusChoices } from "@graphql/generated";

export interface IFormData {
  organizationName?: string;
  title?: string;
  status?: { value: AuthAccountOrganizationJobPositionStatusChoices; label: string };
  date?: Date[];
}

export const getInputConfigs = (hideStatus?: boolean): InputConfig[] => [
  {
    name: "organizationName",
    previewSize: hideStatus ? 4 : 3,
    inputProps: {
      type: "text",
      label: "Company",
      placeholder: "Enter company name",
    },
  },
  {
    name: "title",
    previewSize: hideStatus ? 4 : 3,
    inputProps: {
      type: "text",
      label: "Job Title",
      placeholder: "Enter job title",
    },
  },
  {
    name: "status",
    previewSize: 3,
    hide: hideStatus,
    inputProps: {
      type: "searcher",
      label: "Job Status",
      placeholder: "Select job status",
      labelKey: "label",
      valueKey: "value",
      items: [
        { value: "all", label: "All" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.PUBLISHED, label: "Open" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.SUSPENDED, label: "Suspend" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.SUBMITTED, label: "Submitted" },
        { value: AuthAccountOrganizationJobPositionStatusChoices.EXPIRED, label: "Close" },
      ],
    },
  },
  {
    name: "date",
    previewSize: hideStatus ? 4 : 3,
    inputProps: {
      type: "date",
      label: "Job Date",
      placeholder: "Select date",
      range: true,
    },
  },
];
